"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.insetFocusRing = exports.focusRing = exports.focusRingShadow = void 0;
const polished_1 = require("polished");
const styled_components_1 = require("styled-components");
const component_theme_1 = require("@clds/component-theme");
const focusVisible_1 = require("./focusVisible");
exports.focusRingShadow = (0, styled_components_1.css) `0 0 0 3px ${(0, component_theme_1.combineValues)(component_theme_1.globalTheme.palette.primary, (color) => (0, polished_1.rgba)(color, 0.5))}`;
const focusRingTransition = 'box-shadow 250ms';
// eslint-disable-next-line @typescript-eslint/ban-types
const focusRingCommon = (otherTransition) => otherTransition
    ? (0, styled_components_1.css) `
        outline: none;
        transition: ${focusRingTransition}, ${otherTransition};
      `
    : (0, styled_components_1.css) `
        outline: none;
        transition: ${focusRingTransition};
      `;
const noFocusRingShadow = '0 0 0 0 transparent';
// eslint-disable-next-line @typescript-eslint/ban-types
const focusRing = (otherBoxShadow, otherTransition) => otherBoxShadow
    ? (0, styled_components_1.css) `
        ${focusRingCommon(otherTransition)};
        box-shadow: ${noFocusRingShadow}, ${otherBoxShadow};

        &${(0, focusVisible_1.focusVisible)()} {
          box-shadow: ${exports.focusRingShadow}, ${otherBoxShadow};
        }
      `
    : (0, styled_components_1.css) `
        ${focusRingCommon(otherTransition)};
        box-shadow: ${noFocusRingShadow};

        &${(0, focusVisible_1.focusVisible)()} {
          box-shadow: ${exports.focusRingShadow};
        }
      `;
exports.focusRing = focusRing;
const insetFocusRing = () => (0, styled_components_1.css) `
  ${focusRingCommon()};

  &${(0, focusVisible_1.focusVisible)()} {
    // Solution to have box shadow above content
    // https://stackoverflow.com/questions/13188828/inset-box-shadow-beneath-content
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      box-shadow: inset ${exports.focusRingShadow};
      pointer-events: none;
    }
  }
`;
exports.insetFocusRing = insetFocusRing;
//# sourceMappingURL=focusRing.js.map